import React from 'react'
import {FooterContainer, LogoSectionRounded} from './Styles'
function Footer() {
    return (
        <FooterContainer>
            {/* <div class="container-fluid bg-gray-800 py-5 mb-5">
                <div class="row ">
                    <div class="col d-flex justify-content-center align-items-center">
                      <div class="h4 mt-2 mb-4">STAY CONNECTED</div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col d-flex justify-content-center align-items-center">
                        
                        <a href="#" class="mx-2">
                        <LogoSectionRounded>
                            <img src="facebook.png" alt="facebook" class="w-10"/>
                        </LogoSectionRounded>
                        </a>
                        
                        <a href="#" class="mx-2">
                        <LogoSectionRounded>
                            <img src="instagram.png" alt="instagram" class="w-10"/>
                        </LogoSectionRounded>
                        </a>
                        
                        <a href="#" class="mx-2">
                        <LogoSectionRounded>
                            <img src="discord.png" alt="discord" class="w-10"/>
                        </LogoSectionRounded>
                        </a>
                        
                        <a href="#" class="mx-2">
                        <LogoSectionRounded>
                            <img src="github.png" alt="github" class="w-10"/>
                        </LogoSectionRounded>
                        </a>
                        <a href="#" class="mx-2">
                        <LogoSectionRounded>
                            <img src="email.png" alt="email" class="w-10"/>
                        </LogoSectionRounded>
                        </a>
                    </div>
                </div>
            </div> */}
            <div class="row px-5 my-5">
                
                <div class="col text-center">
                    <strong>
                        sakshambejwani@gmail.com
                    </strong> 
                </div>
                <div class="col text-center">
                    <strong>
                        +91 72096 69398
                    </strong> 
                </div>
            </div>
        </FooterContainer>
    )
}

export default Footer
